/* eslint-disDigitalAssetsable react/jsx-no-constructed-context-values */
import { createContext } from 'react';

const WalletOperationsContext = createContext({});

export default WalletOperationsContext;
